import { RootState } from "@/store/types";
import {ActionTree, Module} from "vuex";
import {ProductDeterminationState} from "@/modules/product_determination/types";
import {
    getProductDetermination,
    getSubassemblyDetermination,
    saveProductDeterminations,
    getProductMaterialDeterminations,
    getItemBillOfMaterials, createProductDeterminationReport
} from "@/services/product_determination";

const actions: ActionTree<ProductDeterminationState, RootState> = {
    async GET_PRODUCT_DETERMINATION(_, payload) {
      return await getProductDetermination(payload);
    },
    async GET_SUBASSEMBLY_DETERMINATION(_, payload) {
        return await getSubassemblyDetermination(payload);
    },
    async SAVE_PRODUCT_DETERMINATIONS(_, payload) {
        return await saveProductDeterminations(payload);
    },
    async GET_PRODUCT_MATERIAL_DETERMINATIONS(_, payload) {
      return await getProductMaterialDeterminations(payload);
    },
    async GET_ITEM_BILL_OF_MATERIALS(_, payload) {
        return await getItemBillOfMaterials(payload);
    },
    async CREATE_PRODUCT_DETERMINATION_REPORT(_, payload) {
        return await createProductDeterminationReport(payload);
    }
}

export const product_determination: Module<ProductDeterminationState, RootState> = {
    actions
}
